import type {
  ContactDataResponse,
  UserContactDataRequestPayload,
  UserLoginRequestPayload,
  UpdatePasswordResponse,
  UserInfoData
} from './types';
import { useDelete, useGet, usePut } from '@/api/lib/integration';

export const deleteUser = useDelete<boolean, void>('/api/user')
export const updateContactData = usePut<UserContactDataRequestPayload, void>('/api/user/contact')
export const updateUserLoginData = usePut<UserLoginRequestPayload, UpdatePasswordResponse>('/api/user')
export const getUserContactData = useGet<void, ContactDataResponse>('/api/user/contact')
export const getUserInfoData = useGet<void, UserInfoData>('/api/kundeinfo')
